import { OrganizationReportEncryptionChartEntity } from '../entities/';
import { authResource } from './Auth';
export const OrganizationReportEncryptionChartResource = authResource({
    path: '/organizations/:organizationId/reports/encryptions/chart/:chartId?',
    schema: OrganizationReportEncryptionChartEntity,
    searchParams: {}
});
